import React from "react";
import './ViewPaper.scss';
import * as constants from "../../../../const/constants";
import *as paperService from '../../../../services/papers';
import Header from "../../../../components/Header/Header";
import CardsFooter from "../../../../components/Modals/Footers/CardsFooter";
import {lang, language} from "../../../../const/language";
import {Button, Col, Container, Row} from "reactstrap";
import 'vimond-replay/index.css';
import i from "react-icofont";
import * as commonFunc from "../../../../utils/commonFunc";
import * as actionModalCreator from "../../../../store/domain/modal/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import * as actionSpinnerCreator from "../../../../store/domain/spinner/action";
import moment from "moment";


class ViewPerson extends React.Component {

    state = {
        paper: undefined,
        StartDate: '',
        StartTime: '',
        EndDate: '',
        EndTime: '',
        LocalDate: '',
        LocalTime: '',
        leaderBoard: [],
        flowType: true
    };

    componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;
    }

    async UNSAFE_componentWillMount(){
        let state = this.props.location.state;
        console.log('Paper View');
        if (state) {
            await this.setState({
                paper: state,
            });

            await this.setState({flowType: state.flowType});

            console.log(this.state.paper);
        } else {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_VIEW_PAPER_ROUTE}`);
        }
    }

    viewLeaderBoard = async (paper) => {
        if (this.state.flowType) {
            const data = {
                "classId": this.state.paper.roleId,
                "quizId": this.state.paper.id,
                "flowType": this.state.flowType
            };

            this.props.history.push({
                pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_LEADERBOARD_ROUTE}`,
                state: {data}
            })
        } else {
            const data = {
                "courseId": this.state.paper.roleId,
                "quizId": this.state.paper.id,
                "flowType": this.state.flowType
            };

            this.props.history.push({
                pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_LEADERBOARD_ROUTE}`,
                state: {data}
            })
        }
    };

    compareAnswers = () => {
        if (this.state.flowType) {

            const data = {
                "classId": this.state.paper.roleId,
                "quizId": this.state.paper.id,
                "enrollId": this.state.paper.classEnrollId,
                "totalQuestions": this.state.paper.noOfQuestions,
                "totalAnswers": this.state.paper.noOfAnswersPerQuestion,
                "flowType": this.state.flowType
            };

            this.props.history.push({
                pathname: `${constants.BASE_ROUTE}${constants.HOME_COMPARE_ANSWERS_ROUTE}`,
                state: {data}
            })
        } else {
            const data = {
                "courseId": this.state.paper.roleId,
                "quizId": this.state.paper.id,
                "enrollId": this.state.paper.courseEnrollId,
                "totalQuestions": this.state.paper.noOfQuestions,
                "totalAnswers": this.state.paper.noOfAnswersPerQuestion,
                "flowType": this.state.flowType
            };
            console.log(data);
            this.props.history.push({
                pathname: `${constants.BASE_ROUTE}${constants.HOME_COMPARE_ANSWERS_ROUTE}`,
                state: {data}
            })
        }
    };

    joinPaper = async (paper) => {

        if (this.state.flowType) {
            const data = {
                "classEnrollId":
                    this.state.paper.classEnrollId === undefined ||
                    this.state.paper.classEnrollId === null ||
                    this.state.paper.classEnrollId === 0 ? 0 : this.state.paper.classEnrollId,
                "quizId": this.state.paper.id,
                "classId": this.state.paper.roleId,
            };
            await paperService.startQuize(data)
                .then(res => {
                    if (res.success) {
                        this.props.spinnerHandler(false);
                        const pdfUrl = res.body.questionPaperUrl;
                        localStorage.setItem("paper", pdfUrl);
                        const remaningTime = res.body.remainingTime;
                        let logTime = new Date();
                        let flowType = this.state.flowType;

                        this.props.history.push({
                            pathname: `${constants.BASE_ROUTE}${paper.quizType === 'MCQ' ?
                                constants.HOME_START_SELECTED_PAPER_ROUTE : constants.HOME_START_ESSAY_SELECTED_PAPER_ROUTE}`,
                            state: {...paper, pdfUrl, remaningTime, logTime, flowType}
                        })
                    } else {
                        commonFunc.notifyMessage(res.message);
                    }
                })
                .catch(error => {
                    //console.log(error)
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(error.message, error.status);
                });
            this.props.spinnerHandler(false);
        } else {
            const data = {
                "courseEnrollId": this.state.paper.courseEnrollId,
                "quizId": this.state.paper.id
            };

            await paperService.startCourseQuiz(data)
                .then(res => {
                    if (res.success) {
                        this.props.spinnerHandler(false);
                        const pdfUrl = res.body.questionPaperUrl;
                        localStorage.setItem("paper", pdfUrl);
                        const remaningTime = res.body.remainingTime;
                        let logTime = new Date();
                        let flowType = this.state.flowType;
                        this.props.history.push({
                            pathname: `${constants.BASE_ROUTE}${paper.quizType === 'MCQ' ?
                                constants.HOME_START_SELECTED_PAPER_ROUTE : constants.HOME_START_ESSAY_SELECTED_PAPER_ROUTE}`,
                            state: {...paper, pdfUrl, remaningTime, logTime, flowType}
                        })
                    } else {
                        commonFunc.notifyMessage(res.message);
                    }
                })
                .catch(error => {
                    //console.log(error)
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(error.message, error.status);
                });
            this.props.spinnerHandler(false);

        }

    };

    toggle = () => this.setState({videoModal: !this.state.videoModal});

    render() {

        const paper = this.state.paper;
        let StartDate = moment(paper.startDateTime).format("YYYY MMM DD ");
        let StartTime = moment(paper.startDateTime).format("h:mm a ");
        let EndDate = moment(paper.endDateTime).format("YYYY MMM DD ");
        let EndTime = moment(paper.endDateTime).format("h:mm a ");
        let state = paper.state;
        console.log(paper);
        const stDate = new Date(paper.startDateTime).getTime();
        const edDate = new Date(paper.endDateTime).getTime();
        const current = new Date().getTime();
        let available = false;

        console.log("stDate", stDate, "edDate", edDate, "current", current);

        if (stDate <= current && current <= edDate) {
            if (paper.quizType === 'MCQ' && (state !== 2 && state !== 3)) {
                //startDate+paperDuration <currentTime ekata wada avil =true else avil =false
                available = true;
            } else if (paper.quizType === 'ESSAY') {
                if (state === 4) {
                    available = true;
                    console.log('state 4')
                } else {
                    const studentStart = new Date(paper.studentQuizStartDateTime).getTime();
                    let diff = (current - studentStart) / 1000;
                    diff /= 60;
                    diff = diff / 60;
                    available = (paper.paperDuration + 15) > Math.abs(Math.round(diff));
                    console.log((paper.paperDuration + 15), " math.abs", Math.abs(Math.round(diff)));
                    console.log(available)
                    // if (studentStart !== null || studentStart !== undefined && current <= edDate) {
                    //     available = true
                    //     console.log('under the else and null value in start paper time')
                    // } else if (studentStart < edDate) {
                    // }

                }
            }
        } else {

        }

        return (
            <div>
                <Header/>
                <main ref="main" className={"viewPaper"}>
                    <div className="backBtnHolder">
                        <button className={"home-btn"}
                                onClick={() => window.history.back()}>

                            <i className="icofont-long-arrow-left"/>
                            {language[lang].BackToTour}
                        </button>
                    </div>
                    <div className="trapezoid "></div>

                    <Container>
                        <Row>
                            <Col lg="8" md="8">
                                <p className={"head-topic"}>{paper.title}</p>
                            </Col>
                            <Col md={4} sm={6} className="mt-3">

                                {
                                    available ?
                                        <div>
                                            <Button
                                                className={"log-btn com-btn bold-text"}
                                                onClick={() => this.joinPaper(paper)}>
                                                {language[lang].startPaperBtnText}
                                            </Button>
                                        </div> :
                                        <div>

                                            <Button className={"log-btn com-btn bold-text"}
                                                    disabled>
                                                {language[lang].unavailabelPaperBtnText}
                                            </Button>
                                        </div>
                                }

                            </Col>
                        </Row>

                        <Row>
                            <Col md={8} className="mt-3">
                                <div>

                                    <p className={"head-description"}>{paper.description}</p>
                                    {
                                        paper.quizType === 'MCQ' &&
                                        <p className={"head-qty"}>
                                            {language[lang].noOfQuestions} -{paper.noOfQuestions}
                                        </p>
                                    }
                                    <p className={"head-qty"}>
                                        {language[lang].paperType}- {paper.quizType}
                                    </p>
                                    {/* <p className={"head-qty"}>
                                        {language[lang].timeAllocation} {paperDura}
                                    </p> */}

                                    <p className={"head-qty"}>
                                        {language[lang].validityText}

                                    </p>
                                    <p className={"head-qty"}>
                                        {StartDate} , {StartTime} {language[lang].fromText}
                                    </p>

                                    <p className={"head-qty"}>
                                        {EndDate} , {EndTime} {language[lang].toText}
                                    </p>
                                    <br/>
                                    <Row>
                                        <Col lg="6" md="6" sm="6">
                                            <Button className={"log-btn com-btn bold-text"}
                                                    disabled={(state !== 2 && state !== 3)}
                                                    onClick={() => this.viewLeaderBoard(paper)}
                                            >
                                                {language[lang].viewLeaderBoardText}
                                            </Button>
                                            <br/>
                                            <br/>
                                            {
                                                paper.quizType === 'MCQ' &&
                                                <Button className={" log-btn com-btn bold-text"}
                                                        disabled={(state !== 2 && state !== 3)}
                                                        onClick={() => this.compareAnswers(paper)}
                                                >
                                                    {language[lang].comapreAnswerText}
                                                </Button>
                                            }
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </main>
                <CardsFooter/>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    purchaseClasses: state.classes.purchaseClasses,
    selectClass: state.classes.selectClass,
    userObj: state.student.userObj
});


const mapDispatchToProps = (dispatch) => ({
    setPaymentModal: (data, value) => dispatch(actionModalCreator.setPaymentModal(data, value)),
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewPerson));

/* Created By Janitha Prashad Katukenda
 jpk Created on Thu Dec 10 2020
Copyright (c) 2020 Ceyentra Technologies
EDULAB */
